import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ResourcesActions from './resources.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ResourcesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ResourcesActions.ResourcesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RESOURCES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ResourcesActions.ResourcesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ResourcesActions.ResourcesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ResourcesActions.ResourcesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ResourcesActions.ResourcesRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new ResourcesActions.ResourcesRefreshByID(data.id));
          break;
      }
    });
  }
}
